import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { css, withStyles } from '../../assets/styles/withStyles';
import { getWork } from '../../redux/selectors/works';
import { loadWork } from '../../redux/actions/works';
import { pad, getImageUrl } from '../../utils';
import Responsive from '../../components/helpers/Responsive';

class WorkDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.loadWork(this.props.location.pathname.split('/')[3]);
  }

  _renderCover() {
    const { styles, work } = this.props;

    return (
      <img
        alt={work.name}
        src={getImageUrl(work.image)}
        {...css(
          styles.coverWrapper,
          !work.description && !work.city && styles.alignInfo
        )}
      />
    );
  }

  render() {
    const { styles, work } = this.props;

    if (!work || !work.category) return null;

    return (
      <div {...css(styles.container)}>
        <Responsive min="desktop">
          <div {...css(styles.top)}>
            <div
              {...css(styles.topInner, styles.text)}
              style={{ paddingLeft: 15 }}
            >
              {work.num && <p {...css(styles.topLeft)}>{pad(work.num, 3)}</p>}
              <p>{work.name}</p>
            </div>
            <div {...css(styles.topInner, styles.text)}>
              <p
                onClick={() => {
                  this.props.history.push('/work');
                }}
                style={{ cursor: 'pointer' }}
              >
                Work
              </p>
              <p
                onClick={() => {
                  this.props.history.push('/work/' + work.category.slug);
                }}
                {...css(styles.topRight)}
                style={{ cursor: 'pointer' }}
              >
                {work.category.name}
              </p>
            </div>
          </div>
        </Responsive>
        <Responsive max="tablet">
          <p
            onClick={() => {
              this.props.history.push('/work');
            }}
            {...css(styles.city, styles.textMobile)}
          >
            <span {...css(styles.span)}>Work</span>
            {work.category.name}
          </p>
          <p
            onClick={() => {
              this.props.history.push('/work/' + work.category.slug);
            }}
            {...css(styles.city, styles.textMobile, styles.locationTop)}
          >
            <span {...css(styles.span, !work.num && styles.noNumMobile)}>
              {work.num && pad(work.num, 3)}
            </span>
            {work.name}
          </p>
        </Responsive>
        {work.city && (
          <p {...css(styles.city, styles.textMobile, styles.location)}>
            <span {...css(styles.span, !work.num && styles.noNumMobile)} />
            {work.city}
          </p>
        )}
        {work.description && (
          <p {...css(styles.description, styles.text)}>{work.description}</p>
        )}

        <div
          {...css(
            styles.info,
            !work.description && !work.city && styles.alignInfo
          )}
        >
          {Object.keys(work.info).map(key => {
            let info = work.info[key];

            return (
              <div
                key={key}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingLeft: 15
                }}
              >
                <div {...css(styles.text, styles.infoKey)}>{key}</div>
                <p {...css(styles.text, styles.infoText)}>
                  {info.replace(/,/g, '\n').replace(' and ', '\n')}
                </p>
              </div>
            );
          })}
        </div>

        {this._renderCover()}

        {work.work_photos.map(photo => (
          <img
            alt={work.name}
            key={photo.id}
            src={getImageUrl(photo.image)}
            {...css(styles.imageWrapper, photo.full_size && styles.fullSize)}
          />
        ))}

        {work.link && (
          <a
            href={work.link}
            target="_blank"
            {...css(styles.link)}
            style={{ fontSize: 14 }}
          >
            Read More
          </a>
        )}

        <div style={{ height: 150 }} />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  work: getWork(state, props.location.pathname.split('/')[3])
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadWork
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    withStyles(({ breakpoints }) => ({
      container: {
        paddingTop: 65,
        paddingRight: 0,
        paddingBottom: 10,
        paddingLeft: 0,

        [breakpoints.md]: {
          paddingTop: 10,
          paddingRight: 0,
          paddingBottom: 10,
          paddingLeft: 0,
          position: 'fixed',
          top: 0,
          right: 0,
          left: '33%',
          bottom: 0,
          overflow: 'scroll'
        }
      },
      top: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      },
      topInner: {
        display: 'flex',
        flexDirection: 'row'
      },
      topRight: {
        marginLeft: 50,
        paddingRight: 15
      },
      topLeft: {
        paddingRight: 50
      },
      city: {
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 26,
        marginBottom: 26,

        [breakpoints.sm]: {
          marginTop: 30,
          marginBottom: 30
        },

        [breakpoints.lg]: {
          marginTop: 33,
          marginBottom: 33
        }
      },
      location: {
        marginTop: 0,

        [breakpoints.sm]: {
          marginTop: 30
        },

        [breakpoints.lg]: {
          marginTop: 33
        }
      },
      locationTop: {
        marginBottom: 0,

        [breakpoints.sm]: {
          marginTop: 30,
          marginBottom: 30
        },

        [breakpoints.lg]: {
          marginTop: 33,
          marginBottom: 33
        }
      },
      description: {
        marginTop: 26,
        marginBottom: 26,
        paddingLeft: 15,
        paddingRight: 15,
        whiteSpace: 'pre-line',

        [breakpoints.sm]: {
          marginTop: 30,
          marginBottom: 30
        },

        [breakpoints.lg]: {
          marginTop: 33,
          marginBottom: 33
        }
      },
      text: {
        fontSize: 16,
        lineHeight: '20px',

        [breakpoints.sm]: {
          fontSize: 26,
          lineHeight: '30px'
        },

        [breakpoints.lg]: {
          fontSize: 27,
          lineHeight: '33px'
        }
      },
      textMobile: {
        fontSize: 22,
        lineHeight: '26px',

        [breakpoints.sm]: {
          fontSize: 26,
          lineHeight: '30px'
        },

        [breakpoints.lg]: {
          fontSize: 27,
          lineHeight: '33px'
        }
      },
      info: {
        width: '100%',
        float: 'left',
        marginBottom: 26,

        [breakpoints.sm]: {
          marginBottom: 30
        },

        [breakpoints.lg]: {
          width: '50%',
          marginBottom: 33
        }
      },
      infoKey: {
        flexBasis: 130,
        flexGrow: 0,
        flexShrink: 0,
        paddingRight: 15,

        [breakpoints.sm]: {
          flexBasis: 180
        }
      },
      infoText: {
        paddingRight: 15,
        whiteSpace: 'pre-line'
      },
      coverWrapper: {
        width: '100%',
        float: 'right',
        marginTop: 9,

        [breakpoints.lg]: {
          width: '50%'
        }
      },
      imageWrapper: {
        width: '100%',

        [breakpoints.sm]: {
          width: '50%',
          marginLeft: '50%'
        }
      },
      fullSize: {
        width: '100% !important',
        marginLeft: '0 !important'
      },
      link: {
        display: 'block',
        marginTop: 30,
        paddingLeft: 15
      },
      span: {
        width: 80,
        display: 'inline-block',

        [breakpoints.md]: {
          width: 'auto',
          display: 'auto'
        }
      },
      noNumMobile: {
        width: 0
      },
      alignInfo: {
        marginTop: 99
      }
    }))(WorkDetails)
  )
);



// WEBPACK FOOTER //
// ./src/containers/WorkDetails/index.js